<script>
  export let voteLabel = 'total';
  /** @type {boolean} */
  export let isBallotMeasure
  // /** @type {boolean} */
  // export let hasParties
  /** @type {boolean} */
  export let face
  /** @type {boolean} */
  export let isPresident

</script>

<thead>
  <tr>

      <th scope="col" colSpan={1} class="contest__candidate-header"></th>

    <th scope="col" colSpan={face ? 2 : 1} class="contest__candidate-header">
      {isBallotMeasure ? 'Support' : 'Candidate'}
    </th>
    <th scope="col" class="contest__candidate-header text-left">
      {#if isPresident}
      <span>State Votes</span>
      {:else}
      <span>Votes</span>
      {/if}
    </th>
    {#if !isPresident}
    <th scope="col" class="contest__candidate-header text-right">
      {voteLabel}
    </th>
    {/if}
    {#if isPresident}
    <th scope="col" class="contest__candidate-header text-left pres-total" aria-label="Percent">
      Pct.
    </th>
    <th scope="col" class="contest__candidate-header text-center border-left" aria-label="U.S. percent">
      <span class="invisible">U.S.</span>
    </th>
    {/if}
  </tr>
</thead>
